import { type FC } from 'react'

import { algoliaProxyRecordAccessorGetDeeplink } from '../../../algolia'
import { useExperimentsContext } from '../../../experiments/components/ExperimentsContext'
import { EXPERIMENTS_TRACK_EVENT_SEARCH_PAGE_PRODUCT_DETAIL_CLICK } from '../../../experiments/eventTracking'
import { useTrackOptimizelyExperimentEvent } from '../../../experiments/hooks/useTrackOptimizelyExperimentEvent'
import { experimentAccessorIsHomeOneSerpEnabled } from '../../../experiments/model/experimentAccessor'

import { useProductSearchResultItemContext } from './ProductSearchResultItemContext/productSearchResultItemContext'

export const ProductSearchResultItemTitle: FC = () => {
  const { algoliaRecord, query = '' } = useProductSearchResultItemContext()

  const { experiments } = useExperimentsContext()

  const trackProductClickEvent = useTrackOptimizelyExperimentEvent(
    EXPERIMENTS_TRACK_EVENT_SEARCH_PAGE_PRODUCT_DETAIL_CLICK,
  )

  const isHomeOneSerpEnable =
    experimentAccessorIsHomeOneSerpEnabled(experiments)

  const {
    __position: position,
    __queryID: queryID = '',
    productName,
  } = algoliaRecord

  return (
    // Switching to `NextLink` investigation under https://jira.shop-apotheke.com/browse/WSAWA-7078
    <a
      className="flex flex-1 self-stretch text-ellipsis text-s font-medium after:absolute after:inset-0 hover:underline"
      data-qa-id="serp-result-item-title"
      href={algoliaProxyRecordAccessorGetDeeplink({
        params: {
          eventName: 'click on product list item',
          position,
          query,
          queryID,
        },
        record: algoliaRecord,
      })}
      onClick={(): void => {
        if (isHomeOneSerpEnable) {
          trackProductClickEvent()
        }
      }}
    >
      {productName}
    </a>
  )
}
